// extracted by mini-css-extract-plugin
export var backgroundStatus1 = "styles-module--backgroundStatus1--861c1";
export var backgroundStatus2 = "styles-module--backgroundStatus2--3da1d";
export var backgroundStatus3 = "styles-module--backgroundStatus3--289f3";
export var backgroundStatus4 = "styles-module--backgroundStatus4--7d5d3";
export var backgroundStatus5 = "styles-module--backgroundStatus5--51579";
export var backgroundStatus6 = "styles-module--backgroundStatus6--2b656";
export var backgroundStatus7 = "styles-module--backgroundStatus7--acb7d";
export var backgroundStatus8 = "styles-module--backgroundStatus8--25928";
export var backgroundStatus9 = "styles-module--backgroundStatus9--57714";
export var badgeFirst = "styles-module--badgeFirst--92ceb";
export var badgeFirstRight = "styles-module--badgeFirstRight--3ddfc";
export var badgeFourth = "styles-module--badgeFourth--28918";
export var badgeFourthRight = "styles-module--badgeFourthRight--06152";
export var badgeSecond = "styles-module--badgeSecond--460a4";
export var badgeSecondRight = "styles-module--badgeSecondRight--df415";
export var badgeThird = "styles-module--badgeThird--60c8a";
export var badgeThirdRight = "styles-module--badgeThirdRight--f1c34";
export var badgesLeftWrapper = "styles-module--badgesLeftWrapper--1c4c0";
export var badgesRightWrapper = "styles-module--badgesRightWrapper--a4fd1";
export var box = "styles-module--box--a476f";
export var container = "styles-module--container--8ea9e";
export var footerBadgeStyle = "styles-module--footerBadgeStyle--3a481";
export var footerCopyStyle = "styles-module--footerCopyStyle--d55ee";
export var footerLink = "styles-module--footerLink--cd68f";
export var footerLinksStyle = "styles-module--footerLinksStyle--7447f";
export var footerNameStyle = "styles-module--footerNameStyle--42fef";
export var linkImg = "styles-module--linkImg--68875";
export var row = "styles-module--row--92e85";